<template>
  <div>
  <div class="flexc-cen-x fixed">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
      <el-option
        v-for="item in DianList"
        :key="item.ID"
        :label="item.StoresName"
        :value="item.ID">
      </el-option>
    </el-select>
  </div>
  <el-container style="padding-top:30px">
      <el-tabs v-model="activeName" style="width:100%;">
        <el-tab-pane label="商品列表" name="first">
          <el-form :inline="true" :model="formInline" class="user-search flex-spc-x" style="height:40px;margin-top:10px">
            <div>
              <el-form-item label="搜索：">
                <el-input size="mini" v-model="formInline.varName" placeholder="输入商品名称、编号"></el-input>
                </el-form-item>
                <el-form-item label="商品类别："  prop="ProjectTypeID">
                    <el-select v-model="formInline.varLable" clearable placeholder="请选择" size="mini">
                      <el-option
                        v-for="item in ListCommodityType"
                        :key="item.ID"
                        :label="item.CommodityTypeName"
                        :value="item.ID">
                      </el-option>
                    </el-select>
                  
                </el-form-item>
                <el-form-item>
                   <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                </el-form-item>
            </div>

          <el-form-item>
           
            <el-button size="mini" type="primary" @click="handleEdit()" v-if="q1 == true">+ 添加商品</el-button>
          </el-form-item>
          </el-form>
      <div>
       <el-table  :data="tableData" highlight-current-row v-loading="loading" size="mini" border element-loading-text="拼命加载中" style="width:100%;">
          <el-table-column
            prop="CommodityNO"
            label="编号"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            align="center"
            prop="CommodityName"
            label="商品名称"
            width="150">
          </el-table-column>
          <el-table-column
            align="center"
            prop="CommodityTypeName"
            label="类型"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="CommoditysafetyKC"
            label="安全库存"
          >
          </el-table-column>
                    <el-table-column
            align="center"
            prop="CommodityNum"
            label="库存"
          >
          </el-table-column>
             <el-table-column label="规格"
                align="center"
             >
            <el-table-column
                  prop="province"
                  label="编号"
                  align="center"
                  >
                  <template slot-scope="scope" style="width:100%" >
                    <div class="flex-xy " style="width:100%" v-for="items in scope.row.listCommodityPrice">
                        <div class="border flex-xy" style="height:40px">{{items.CommodityNO}}</div>
                    </div>
                   </template>
            </el-table-column>
              <el-table-column
                  prop="province"
                  label="名称"
                  align="center"
                  >
                  <template slot-scope="scope" style="width:100%" >
                    <div class="flex-xy " style="width:100%" v-for="items in scope.row.listCommodityPrice">
                        <div class="border flex-xy" style="height:40px">{{items.Specname}}</div>
                    </div>
                   </template>
                </el-table-column>
                 <el-table-column
                  prop="city"
                  label="价格"
                  align="center"
                  >
                  <template slot-scope="scope" style="width:100%" >
                  <div class="flex-xy " style="width:100%" v-for="items in scope.row.listCommodityPrice">
                        <div class="border flex-xy" style="height:40px">{{items.procurementPrice}}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="city"
                  label="库存"
                   align="center"
                 >
                 <template slot-scope="scope" style="width:100%" >
                    <div class="flex-xy " style="width:100%" v-for="items in scope.row.listCommodityPrice">
                      <div class="border flex-xy" style="height:40px">{{items.CommodityNum}}</div>
                    </div>
                  </template>
                </el-table-column>
             </el-table-column>
          <el-table-column
            align="center"
            prop="procurementPrice"
            label="售价"
          >
           </el-table-column>
          <el-table-column
            align="center"
            prop="YJPrice"
            label="原价"
          >
           </el-table-column>
          <el-table-column
            align="center"
            prop="floorPrice"
            label="底价"
          >
           </el-table-column>
            <el-table-column
              align="center"
            prop="isSoldout"
            label="是否售罄"
          >
             <template slot-scope="scope" style="width:100%" >
                <span class="Danger" v-if="scope.row.isSoldout == 1">已售罄</span>
                 <span class="Success" v-if="scope.row.isSoldout == 0">未售罄</span>
             </template>
           </el-table-column>
                       <el-table-column
              align="center"
            prop="ishyzk"
            label="会员打折"
          >
             <template slot-scope="scope" style="width:100%" >
                <span class="Success" v-if="scope.row.ishyzk == 1">是</span>
                 <span class="Danger" v-if="scope.row.ishyzk == 0">否</span>
             </template>
           </el-table-column>
          <el-table-column
            align="center"
            prop="floorPrice"
         fixed="right"
         width="350"
            label="操作"
          >
           <template slot-scope="scope">
              <el-button size="mini"  @click="handleEdit(scope.row)" v-if="q2 == true" >编辑</el-button>

              <el-button size="mini" plain  type="info" v-if="scope.row.isshelves == 1 && q4 == true"    @click="handlejin(scope.row)">下架</el-button>
              <el-button size="mini" type="success" plain  v-if="scope.row.isshelves == 0 && q4 == true"    @click="handlejie(scope.row)">上架</el-button>
              <el-button  size="mini" type="warning" plain   @click="handleshou(scope.row)">修改售罄</el-button>
                            <el-button size="mini" type="info"    @click="delGoods(scope.row)" v-if="q3 == true">删除</el-button>
              <!-- <el-button icon="el-icon-upload2" class="Success" v-if="scope.row.isSoldout == 1" type="text"   @click="handlewei(scope.row)">未售罄</el-button> -->
           </template>
           </el-table-column>
      </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather" style="margin-bottom:30px"></Pagination>
    </div>
        </el-tab-pane>
        <el-tab-pane label="商品规格设置" name="second">
          <div style="width:100%">
            <div class="flex-spc-x" style="width:100%">
                <div>
                  
                </div>
                <div>
                   <el-button size="mini" type="primary" @click="showdUni()">+ 添加规格</el-button>
                </div>
            </div>
            <div class="mainSup" v-for="(item,index) in supList" style="margin-top:20px" >
              <div class="flexc-cen-x top">
                  <div><i class="el-icon-s-unfold" style="font-size:25px;color:#808080"></i></div>
                  <el-input v-model="item.SpecificationName" placeholder="请输入内容" size="small" @blur="checkBlur(item)" style="width:180px;margin-left:10px"></el-input>
                    <img class="cursor" src="../../assets/add.png" alt=""   @click="topush(item)" style="width:30px;height:30px;margin-left:5px">
                    <!-- <el-button icon="el-icon-minus" circle size="mini"></el-button> -->
                    <img class="cursor" src="../../assets/del.png" alt=""   @click="toDelsup(item)" style="width:25px;height:25px;margin-left:5px">
                  

              </div>
              <div style="display:flex;flex-wrap:wrap;margin-left:20px">
                <div class="flexc-cen-x" v-for="(items,index) in item.listSub" style="margin-right:10px;margin-top:10px">
                  <el-input v-model="items.SpecificationName" placeholder="请输入内容" size="small" @blur="checkin(items)" style="width:180px"></el-input>
                    <div class="" style="margin-left:10px">
                     
                      <el-button type="text" size="mini" @click="toDelitem(items)"><i class="el-icon-delete" style="font-size:13px"> </i> </el-button>
                  </div>
              </div>
              </div>
            </div>
            <div class="flex-xy" style="width:100%;margin-top:20vh"  v-if="supList.length == 0">
                <img src="../../assets/zanwu.png" alt="" style="width:100px;height:100px">
                <div style="color:#808080">暂无数据</div>
            </div>
          </div>

        </el-tab-pane>
      
      </el-tabs>
  </el-container>

    <!--列表-->

    <!-- 分页组件 -->
    
    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="48%">
      <el-tabs v-model="activeName1"  style="padding-left:10px;padding-right:10px;padding-bottom:150px">
        <el-tab-pane label="基础配置" name="first">      
        <el-form label-width="100px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="商品名称:" prop="CommodityName">
          <el-input size="small" v-model="editForm.CommodityName" auto-complete="off" placeholder="请输入商品名称"  style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item label="商品编号:" prop="CommodityNO">
          <el-input size="small" v-model="editForm.CommodityNO" auto-complete="off" placeholder="请输入商品编号"  style="width: 215px"></el-input>
        </el-form-item>
        
          <el-form-item label="商品类别:" prop="CommodityType" >
            <el-select v-model="editForm.CommodityType" placeholder="请选择" size="small">
                <el-option
                  v-for="item in typeList"
                  :key="item.ID"
                  :label="item.CommodityTypeName"
                  :value="item.ID">
                </el-option>
              </el-select>
                <el-button type="text" @click="toSetting">设置</el-button>
           </el-form-item>
          <el-form-item label="商品单位:" prop="CommodityUnit" >
            <el-select v-model="editForm.CommodityUnit" placeholder="请选择" size="small">
                <el-option
                  v-for="item in unitList"
                  :key="item.ID"
                  :label="item.UnitName"
                  :value="item.ID">
                </el-option>
            </el-select>
              <el-button type="text"   @click="toshow">设置</el-button>
           </el-form-item>
          <el-form-item label="商品图片:" prop="CommodityImg">
                <div class="list-img-box cursor">
                  <div v-if="editForm.CommodityImg !== ''">
                    <img
                      :src="editForm.CommodityImg"
                      style="width: 100px; height: 100px"
                      alt="图片"
                        @click="uploadPicture('HeadUrl')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('HeadUrl')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                  <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="editForm.CommodityImg"
                  placeholder="请添加头像"
                />
          </el-form-item>
          <el-form-item label="商品售价:" prop="procurementPrice" >
            <el-input size="small" v-model="editForm.procurementPrice" type="number" auto-complete="off" placeholder="请输入价格"  style="width: 215px"></el-input> 元
          </el-form-item>
          <el-form-item label="商品原价:" prop="YJPrice" >
           <el-input size="small" v-model="editForm.YJPrice" type="number" auto-complete="off" placeholder="请输入价格"  style="width: 215px"></el-input> 元
         </el-form-item>
          <el-form-item label="商品底价:" prop="floorPrice" >
            <el-input size="small" v-model="editForm.floorPrice" type="number" auto-complete="off" placeholder="请输入价格"  style="width: 215px"></el-input> 元
          </el-form-item>
        <el-form-item label="商品数量:" prop="CommodityNum">
          <el-input-number v-model="editForm.CommodityNum" size="small" :step="1" :min="0" step-strictly ></el-input-number> 
        </el-form-item>
        <el-form-item label="安全库存:" prop="CommoditysafetyKC">
          <el-input-number v-model="editForm.CommoditysafetyKC" size="small" :step="1" :min="0" step-strictly ></el-input-number> 
        </el-form-item>
        <el-form-item label="是否售罄:" prop="isSoldout">
             <el-radio-group v-model="editForm.isSoldout">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="会员打折:" prop="ishyzk">
             <el-radio-group v-model="editForm.ishyzk">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="上架:" prop="isshelves">
            <el-radio-group v-model="editForm.isshelves">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="线上购买:" prop="IsPay">
            <el-radio-group v-model="editForm.IsPay">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>

          <el-form-item label="轮播图:" prop="mainImage">
            <div class="flexc-cen-x">
                <div class="list-img-box cursor">
                  <div v-if="img1 !== ''">
                    <img
                      :src="img1"
                    style="width: 121px; height: 81px"
                      alt="图片"
                       @click="uploadPicture('img1')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('img1')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                    <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>

                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <div class="list-img-box cursor" style="margin-left:10px">
                  <div v-if="img2 !== ''">
                    <img
                      :src="img2"
                      style="width: 121px; height: 81px"
                      alt="图片"
                        @click="uploadPicture('img2')"
                    />
                  </div>

                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('img2')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                  <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <div class="list-img-box cursor" style="margin-left:10px">
                  <div v-if="img3 !== ''">
                    <img
                      :src="img3"
                      style="width: 121px; height: 81px"
                      alt="图片"
                       @click="uploadPicture('img3')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('img3')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                     <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
            </div>
                <!-- <input
                  type="hidden"
                  v-model="formValidate.mainImage"
                  placeholder="请添加轮播图"
                /> -->
          </el-form-item>
        <el-form-item label="商品简介:" prop="ProjectIntroduction">
           <el-input type="textarea" :rows="2" placeholder="请输入商品简介" v-model="editForm.CommodityInfo" style="width:90%"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="ProjectIntroduction">
           <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.note" style="width:90%"></el-input>
        </el-form-item>
      </el-form></el-tab-pane>
        <el-tab-pane label="规格配置" name="second" :key="timer">
          <el-form label-width="100px"  >
            <el-form-item label="选择规格:" prop="isjp">
              <el-button type="text"  @click="toChoose">选择</el-button>
            </el-form-item>
          </el-form>
          <div class="flexc-cen-x" style="color:#808080;font-size:15px">
            <div class="flex-xy" style="width:20%">
              编号
            </div>
            <div class="flex-xy" style="width:30%">
              规格
            </div>
            <div class="flex-xy" style="width:25%">
              库存
            </div>
            <div class="flex-xy" style="width:25%">
              价格(元)
            </div>

          </div>
          <div class="flexc-cen-x" v-for="(items,index) in chooseList" v-if="items.state != 3 || !items.state" style="margin-top:10px">
            <div class="flex-xy" style="width:20%">
                  <el-input size="small" v-model="items.CommodityNO" auto-complete="off" placeholder="请输入价格"  style="width: 140px" @change="toState(items)"></el-input>
            </div>
            <div class="flex-xy" style="width:30%">
                <el-input
                placeholder="请输入内容"
                v-model="items.Specname"
                :disabled="true"
                size="small"
                style="width:180px"
                >
              </el-input>
            </div>
            <div class="flex-xy" style="width:25%">
                   <el-input-number v-model="items.CommodityNum" :step="1" :min="1" size="small" @change="toState(items)"></el-input-number>
            </div>
            <div class="flex-xy" style="width:25%">
              <div>
                       <el-input size="small" v-model="items.procurementPrice" type="number" auto-complete="off" placeholder="请输入价格"  style="width: 120px" @change="toState(items)"></el-input>
                <el-button type="text" size="mini" @click="delNUm(index,items)"><i class="el-icon-delete" style="font-size:15px"> </i> </el-button>
              </div>
          
            </div>

            
          </div>


        </el-tab-pane>
    
        <el-tab-pane label="图文详情" name="third">
            <Editor :key="timer" v-show="activeName1 == 'third'" v-bind:value="editForm.CommodityIntroduce" v-model="editForm.CommodityIntroduce"  style="margin-bottom:150px;margin-top:-10px">
            </Editor>
        </el-tab-pane>
      
      </el-tabs>

        <div class="demo-drawer__footer flex-spc-x"  style="width:48%">
          <div>
      
          </div>
  <div>

          <el-button size="small" @click="closeDialog">取消</el-button>
          
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            @click="submitForm('editForm')"
            >保存</el-button
          >
  </div>
        </div>
    </el-drawer>
    <!-- </el-dialog> -->
    <el-dialog title="添加规格" :visible.sync="supShow" :direction="direction" width="40%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
        <el-form label-width="120px" >
            <el-form-item label="规格名称:" prop="SpecificationName">
            <el-input size="small" v-model="SpecificationName"  placeholder="请输入规格名称"  style="width: 215px"></el-input>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="addsup('editForm')">确定</el-button>
        </div>

    </el-dialog>
     <el-dialog title="选择规格" :visible.sync="chooseShow" :direction="direction" >
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
     <el-table
    ref="multipleTable"
    :data="supList"
    tooltip-effect="dark"
     max-height="300px"
    border
    @selection-change="handleSelectionChange">
    <el-table-column
      type="selection"
     >
    </el-table-column>
      <el-table-column
          label="编号"
         >
          <template slot-scope="scope">{{ scope.row.ID}}</template>
        </el-table-column>
        <el-table-column
          label="规格类型"
         >
          <template slot-scope="scope">{{ scope.row.SpecificationName }}</template>
        </el-table-column>

  </el-table>

        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="chooseShow = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="downLoad()">下一步</el-button>
        </div>

     </el-dialog>
    <el-dialog title="选择规格" :visible.sync="upShow" :direction="direction" >

        <div style="margin-top:-20px">
          <div v-for="(item,index) in val" style="margin-top:10px">
            <span style="font-size:15px;font-weight:600">
              {{item.SpecificationName}}：
              <el-checkbox-group size="medium"   v-model="checkedCities"  @change="handleCheckedCitiesChange" style="margin-top:10px">
                   <el-checkbox  v-for="(items) in item.listSub" :key="items.ID" :label="items.ID" >{{items.SpecificationName}}</el-checkbox>
              </el-checkbox-group>
            </span>

          </div>
        </div>


        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="upShow = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="suresup('editForm')">确定</el-button>
        </div>

    </el-dialog>
    <el-dialog title="单位列表" :visible.sync="showUnit" :direction="direction" width="500px" > 
      <div class="flex-spc-x" style="width:100%;margin-top:-20px;margin-bottom:10px">
        <div>   
        </div>
        <div>
          <el-button size="mini" type="primary" @click="addUnit()">+ 添加单位</el-button>
        </div>
      </div>
     <el-table
        ref="multipleTable"
      :data="unitList"
      tooltip-effect="dark"
      max-height="300px"
      size="small"
      style="width:450px"
    >
        <el-table-column
          label=""
         >
          <template slot-scope="scope">
            <div class="flexc-cen-x">
                <div style="width:350px">
                      {{ scope.row.UnitName }}
                </div>
              <el-button type="text" size="mini" icon="el-icon-delete" class="Danger" v-if="scope.row.isAdmin != 1"  @click="toshan(scope.row)">删除</el-button>
            </div>
          
            </template>
        </el-table-column>
     

  
    </el-table>

        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="showUnit = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="showUnit = false">确定</el-button>
        </div>

     </el-dialog>
     <el-dialog title="添加单位" :visible.sync="passShow" width="40%" @click="closeUnit">
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="规格" prop="deptNo">
          <el-input size="small" placeholder="请输入规格" v-model="Pwd" auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeUnit">取消</el-button>
        <el-button size="small" type="primary"   @click="topass()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改单位" :visible.sync="passShow1" width="40%" @click="closeUnit">
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="规格" prop="deptNo">
          <el-input size="small" placeholder="请输入规格" v-model="Pwd" auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeUnit">取消</el-button>
        <el-button size="small" type="primary"   @click="sureEdit()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
              title="裁切封面"
              :visible.sync="cropperModel"
              width="1200px"
              center
            >
             <cropper-image
                :Name="cropperName"
                @uploadImgSuccess="handleUploadSuccess"
                ref="child"
                :key="timer"
              >
              </cropper-image> 
    </el-dialog>

 <el-dialog title="商品类别" :visible.sync="vipShow" width="60%" @click="vipShow = false">
  <el-button size="mini" type="primary" style="float:right;margin-top:-20px"   icon="el-icon-plus" @click="handleEdit1()">添加</el-button>
      <el-table  :data="typeList" highlight-current-row v-loading="loading" size="small"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">

          <el-table-column  prop="CommodityTypeName" label="类别名称">
            
          </el-table-column>


        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit1(scope.row)" >编辑</el-button>
            <el-button size="mini" type="info" @click="deleteUser1(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

 </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog :title="title1" :visible.sync="editFormVisible1" :direction="direction" width="40%">
      
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
        <el-form label-width="120px" :model="editForm1" :rules="rules1" ref="editForm1">
            <el-form-item label="类别名称:" prop="CommodityTypeName">
            <el-input size="small" v-model="editForm1.CommodityTypeName"  placeholder="请输入类别名称"  style="width: 215px"></el-input>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="editFormVisible1 = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading" @click="submitForm1('editForm1')">确定</el-button>
        </div>

    </el-dialog>

            <!--查看大封面-->
    <el-dialog title="查看大封面" :visible.sync="imgVisible" center>
        <img
          :src="imgName"
          v-if="imgVisible"
          style="width: 100%"
          alt="查看"
        />
    </el-dialog>

  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
import  Editor from '../../components/editor'
export default {
  data() {
    return {
      formValidate: {
        mainImage: "",
      },
      showUnit:false,
      cropperName:'',
      imgVisible: false,
      img1:'',
      img2:'',
      img3:'',
      timer:'',
      SelectStoresID:localStorage.getItem("StoresID"),
      supShow:false,
       rules1: {
        CommodityTypeName: [{ required: true, message: '请输入类别名称', trigger: 'blur' }],
        //   Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        //   Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        //   pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        //   money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
        //   ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      SpecificationName:'',
      activeName1:'first',
      activeName: 'first',
      value:true,
      direction: "ltr",
      passShow:false,
      passShow1:false,
      money:'',
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible:false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      supList:[],
      ListCommodityType:[],
      Pwd:'',
      vipShow:false,
      editForm: {

        SupIds:'',
        SubIds:'',
        GraphicDetails:'',
        CommodityImg:'',
        YJPrice:'',
        floorPrice:'',
        procurementPrice:'',
        isshelves:1,
        IsPay:1,
        CommodityNum:1,
        CommoditysafetyKC:1,
        isSoldout:0,
        CommodityInfo:'',
        CommodityIntroduce:'',
        CommodityImg:'',
        lbimgs:'',
        ishyzk:1,
      },
      typeList:[],
      unitList:[],
      val:[],
      Pwd:'',
      // rules表单验证
      cropperModel: false,
      rules: {
        CommodityName: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        CommodityNO: [{ required: true, message: '请输入商品编号', trigger: 'blur' }],
        CommodityType: [{ required: true, message: '请选择商品类别', trigger: 'blur' }],
        CommodityUnit: [{ required: true, message: '请选择商品单位', trigger: 'blur' }],
        YJPrice:[{ required: true, message: '请输入原价', trigger: 'blur' }],
        floorPrice:[{ required: true, message: '请输入底价', trigger: 'blur' }],
        procurementPrice:[{ required: true, message: '请输入售价', trigger: 'blur' }],
        //  CommodityImg: [{ required: true, message: '请选择商品图片', trigger: 'blur' }],
       
      },
      DianList:[],
      chooseShow:false,
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      unID:'',
      checkedCities:[],
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      upShow:false,
      userparm: [], //搜索权限
      listData: [], //用户数据
      chooseList:[],
    
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      title1:'',
      editForm1:{},
        Limits:[],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
    editFormVisible1:false,
    }
  },
  // 注册组件
  components: {
    Editor,
    Pagination,
    CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
       if(localStorage.getItem('isAdmin') == 1){

          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true

      }
      this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {

            if(items == 96)
            this.q1  =true
            if(items == 97)
            this.q2 = true
            if(items == 98)
            this.q3 = true
            if(items == 99)
            this.q4 = true


      })
    //    this.getType()
    this.getDianList()
    this.getsupList()
    this.getList()
    this.getType()
    this.getUnitList()
    this.getListCommodityType()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
        submitForm1(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            var data = this.editForm1
                 data.CommodityTypeName = this.editForm1.CommodityTypeName
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                var that = this
            if(this.title1 == '添加商品类别'){
                this.ajax('addCommodityType.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.editFormVisible1 = false
                         that.getType()
                     }

                })

            }else {
                data.CommodityTypeID =  this.editForm1.ID
                 this.ajax('editCommodityType.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "修改成功",duration:2000
                        });
                        that.editFormVisible1 = false
                        that.getType()
                     }

                })
            }
        } else {
          return false
        }
      })
    },
           deleteUser1(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token"),
            CommodityTypeID:row.ID,
        
        }
        var that = this
        this.ajax('delCommodityType.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
        
              that.getType()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },

    handleEdit1(row){
          if (row != undefined && row != 'undefined') {
              this.title1 = '编辑商品类别'
       
              this.editForm1 = row
              this.editForm1.CommodityTypeName = this.editForm1.CommodityTypeName
            //   this.editForm.preferentialType = Number(this.editForm.preferentialType) 
    
          } else {
              this.title1 = '添加商品类别'
                this.editForm1 = {
                    preferentialType:2,
                    CommodityTypeName:'',
                    preferentialvalue:100,
                }
          }
          this.editFormVisible1 = true
    },
    toSetting(){
      this.vipShow = true
    },

    handleshou(row){
      var isSoldout = 0
      if(row.isSoldout == 0){
        isSoldout = 1
      } else {
        isSoldout = 0
      }
       this.$confirm('是否修改售罄状态?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CommodityID:row.ID,
          isSoldout:isSoldout

      }
        var that = this
       this.ajax('editCommodityisSoldout.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                        });
              that.getList()
               
            }

      })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消修改'
          })
        })
    },
    handlejin(row){
 this.$confirm("确定要下架吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          CommodityID:row.ID,
           isshelves:0
        }
        var that = this
        this.ajax('editCommodityisshelves.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "下架成功",duration:2000,
              });
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
        
        });
   
},
handlejie(row){
 this.$confirm("确定要上架吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          CommodityID:row.ID,
          isshelves:1
        }
        var that = this
        this.ajax('editCommodityisshelves.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "上架成功",duration:2000,
              });
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
         
        });
   
},
    delGoods(items){
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CommodityID:items.ID,
      }
        var that = this
       this.ajax('delCommodity.aspx ',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                            type: "success",
                            message: "刪除成功",duration:2000,
                        });
              that.getList()
               
            }

      })
        })
       
    },
    toState(items){
        console.log(items)
        items.state = 2
    },
    sureEdit(){
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          UnitName:this.Pwd,
          UnitID:this.unID
      }
      var that = this
      this.ajax('editUnit.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                    type: "success",
                   message: "修改成功",duration:2000,
              });
              that.getUnitList()
              that.closeUnit()
                // that.unitList = res.data
                //  loading.close();
          } 
       })
    },
    toedit(item){
        this.unID = item.ID
        this.Pwd = item.UnitName
        this.passShow1 = true
    },
    toshan(item){
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          UnitID:item.ID,
      }
        var that = this
       this.ajax('delUnit.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                            type: "success",
                            message: "刪除成功",duration:2000,
                        });
              that.getUnitList()
               
            }

      })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    topass(){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          UnitName:this.Pwd
      }
      var that = this
      this.ajax('addUnit.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                    type: "success",
                   message: "添加成功",duration:2000,
              });
              that.getUnitList()
              that.closeUnit()
                // that.unitList = res.data
                //  loading.close();
          } 
       })
    },

    closeUnit(){
      this.passShow = false
      this.passShow1 = false
    },
    toshow(){
      this.showUnit = true
    
    },
    addUnit(){
       this.Pwd = ''
      this.passShow = true
    },
    delNUm(index,items){
      if(this.title == '修改商品'){
             items.state = 3
      } else {  
         this.chooseList.splice(index, 1)
         
      }
        this.timer = new Date().getTime()
    },
      handleSelectionChange(val) {
        this.val = val
    

      },
      downLoad(){
          this.chooseShow  = false
          this.upShow = true
      },
    handleCheckedCitiesChange(){
      console.log(this.checkedCities)
    },
    toChoose(){
          this.chooseShow = true
      

    },
    getUnitList(){
       var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
 
      }
      var that = this
      this.ajax('getListUnit.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
          
                that.unitList = res.data
                //  loading.close();
          } 
       })
    
    },getListCommodityType(){
    var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,

      }
     
      
        var that = this
      this.ajax('getListCommodityType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                 that.ListCommodityType = res.data
           } 

      })
    },
    uploadPicture(name) {
        this.timer = new Date().getTime()
      this.cropperName = name;
      this.cropperModel = true;
    },
        handleUploadSuccess(data) {
       this.cropperModel = false
      if(this.cropperName == 'KFQrCode'){
        this.editForm.KFQrCode = data.url

      }
      if(this.cropperName == 'HeadUrl'){
          this.editForm.CommodityImg = data.url
      }
      if(this.cropperName == 'img1'){
          this.img1 = data.url
      }
            if(this.cropperName == 'img2'){
          this.img2 = data.url
      }
            if(this.cropperName == 'img3'){
          this.img3 = data.url
      }

      this.cropperModel = false;
    },
     getType(){
      var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
      }
      var that = this
      this.ajax('getListCommodityType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.typeList = res.data
                //  loading.close();
          } 
       })
    
    },
    getList(){
       var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          selectName:this.formInline.varName,
          CommodityType:this.formInline.varLable,
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListCommodity.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                that.pageparm.total = res.allcount

                 loading.close();
          } 

      })
    },
    topush(items){
        console.log(items)
        if(items.listSub.length == 0){
          var list = {
            SpecificationName:'',
            SupId:items.ID
          }
          items.listSub.push(list)
        } else if(items.listSub[items.listSub.length - 1].SpecificationName == ''){
             this.$message({ type: "error", message: "请输入前一个项规格名称" ,duration:1000});
             return;
        } else {
                       var list = {
            SpecificationName:'',
            SupId:items.ID
          }
          items.listSub.push(list)
        }
    },
    suresup(){
       this.$confirm('重置将覆盖现有的规格', '重置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
  var list = []
       this.val.forEach(items => {
         list.push(items.ID)
      });
       list =  list.join(',')
        var list1 = this.checkedCities.join(',')
        this.editForm.SupIds = list
        this.editForm.SubIds = list1
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SupIds:list,
          SubIds:list1,
      }
      var that = this
      this.ajax('getListsSpecInfo.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
          
                  that.chooseList = res.data
                  that.chooseList.forEach(items => {
                      items.state = 1
                  });
                  that.editForm.iscz = 1
                  that.chooseShow =false
                  that.upShow = false
                //  loading.close();
          } 
       })
    
        })
        .catch(() => {
          
        })
     
    },
  toDelsup(item){
   this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SpecificationID:item.ID,
      }
        var that = this
       this.ajax('delSpecificationSup.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                            type: "success",
                            message: "刪除成功",duration:2000,
                        });
              that.getsupList()
               
            }

      })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    toDelitem(item){
   this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SpecId:item.ID,
      }
        var that = this
       this.ajax('delSpecification.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                            type: "success",
                            message: "刪除成功",duration:2000,
                        });
              that.getsupList()
               
            }

      })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    checkBlur(item){
        if(item.SpecificationName == ''){
               this.$message({ type: "error", message: "请输入规格名称" ,duration:1000});
                          return;
        }
     
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SpecificationName:item.SpecificationName,
          SpecificationID:item.ID,
      }
        var that = this
       this.ajax('editSpecificationSup.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {

                that.getsupList()

            }

      })
    },
    checkin(items){
        if(items.SpecificationName == ''){
          this.$message({ type: "error", message: "请输入规格名称" ,duration:1000});
               return;
        }
        if(items.ID){
      var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SpecificationName:items.SpecificationName,
          SpecId:items.ID,
      }
        var that = this
       this.ajax('editSpecification.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
             
              that.getsupList()
               
            }

      })

        } else {
          var data = { 
            SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            SpecificationName:items.SpecificationName,
            SupId:items.SupId,
        }
        var that = this
       this.ajax('addSpecification.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
             
              that.getsupList()
               
            }

      })
        }
        
    },
      changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    
      this.getList()
      this.getsupList()
    },
    getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
},
    addsup(){
      if(this.SpecificationName== ''){
         this.$message({ type: "error", message: "请输入规格名称" ,duration:1000});
                          return;
      }
          var data = {}
                data.SpecificationName= this.SpecificationName
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                var that = this
         
                this.ajax('addSpecificationSup.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                        });
                        that.supShow = false
                        that.getsupList()
                     }

                })
 

    },
    getsupList(){

       var data = {}
                data.SpecificationName= this.SpecificationName
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                var that = this
         
                this.ajax('getListSpecification.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                      
                        that.supList = res.data
                    
                     }

                })
 
    },
    showdUni(){
      this.SpecificationName= ''
      this.supShow = true
    },

    handlePassword(row){
      // this.editForm.ManageLoginID = row.ID
      this.Pwd = ''
      this.passShow = true

    },
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
       this.chongShow = true
      this.money = ''
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
       this.getList()

    },
    //显示编辑界面
    handleEdit: function(row) {
     this.activeName1 = 'first'
     this.activeName = 'first'
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改商品'
        
         var data = {}
             data.SpecificationName= this.SpecificationName
             data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                data.CommodityID = row.ID
                var that = this
            
                this.ajax('getCommodityInfo.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                      that.editForm = res.data
                      // that.chooseList = res.data.listCommodityPrice
                      that.editForm.iscz = 0
                      that.editForm.isshelves = Number(that.editForm.isshelves)
                      that.editForm.isSoldout = Number(that.editForm.isSoldout)
                      that.editForm.IsPay = Number(that.editForm.IsPay)
                      that.editForm.ishyzk = Number(that.editForm.ishyzk)
                        // that.supList = res.data
                  }

          })
        var data = {}
              data.SpecificationName= this.SpecificationName
             data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")
                data.SelectStoresID  = this.SelectStoresID
                data.CommodityID = row.ID
                var that = this
            
                this.ajax('getListCommodityPrice.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                      that.chooseList = res.data
                      // that.chooseList = res.data.listCommodityPrice
                      // that.editForm.iscz = 0
                      // that.editForm.isshelves = Number(that.editForm.isshelves)
                      // that.editForm.isSoldout = Number(that.editForm.isSoldout)
                      // that.editForm.IsPay = Number(that.editForm.IsPay)
                        // that.supList = res.data
                  }

          })

      } else {
        this.title = '添加商品'
       this.editForm={
          SupIds:'',
          SubIds:'',
          GraphicDetails:'',
          CommodityImg:'',
          YJPrice:'',
          floorPrice:'',
          procurementPrice:'',
          isshelves:1,
          IsPay:1,
          CommodityNum:1,
          CommoditysafetyKC:1,
          isSoldout:0,
          CommodityInfo:'',
          CommodityIntroduce:'',
          CommodityImg:'',
          lbimgs:'',
          ishyzk:1,
       }  
      if(this.typeList.length == 1){
          this.editForm.CommodityType = this.typeList[0].ID
        }
      } 
           this.editFormVisible = true
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
          this.editForm.lbimgs = ''
          if(this.img1 !='' && this.img1 )
            this.editForm.lbimgs = this.editForm.lbimgs + this.img1 + ','
          if(this.img2 !='' && this.img2)
            this.editForm.lbimgs = this.editForm.lbimgs   +this.img2  + ','
          if(this.img3 !=''&& this.img3)
            this.editForm.lbimgs = this.editForm.lbimgs  + this.img3
            if(this.title == '添加商品'){
                this.add()
            }else {
                this.edit()
            }
        } else {
          return false
        }
      })
    },

edit(){
  if(this.chooseList.length != 0){
      this.editForm.listCommodityPrice =  this.chooseList
  } else {
    this.editForm.listCommodityPrice = ''
  }
     var that = this
            var data = this.editForm
            data.CommodityID = data.ID
            data.token=localStorage.getItem("token")
            data.SelectStoresID = this.SelectStoresID
            data.StoresID=localStorage.getItem("StoresID")
  
 this.ajax('editCommodity.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                    type: "success",
                   message: "修改成功",duration:2000,
              });
              that.getList()
              that.closeDialog()
                // that.unitList = res.data
                //  loading.close();
          } 
       })
},
add(){
  if(this.chooseList.length != 0){
      this.editForm.listCommodityPrice =  this.chooseList
  } else {
    this.editForm.listCommodityPrice = ''
  }
     var that = this
            var data = this.editForm
            data.token=localStorage.getItem("token")
            data.SelectStoresID = this.SelectStoresID
            data.StoresID=localStorage.getItem("StoresID")
  
 this.ajax('addCommodity.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
                    type: "success",
                   message: "添加成功",duration:2000,
              });
              that.getList()
              that.closeDialog()
                // that.unitList = res.data
                //  loading.close();
          } 
       })
},



    toDel(){
        this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.delete(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.delete(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.supShow  = false
      this.passShow = false
      this.chongShow = false
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.border{
  width: 100%;
  border-bottom:1px solid #eeeeee;
}
.top{
  border-bottom:1px solid #eeeeee;
  padding-bottom: 10px;
}
.mainSup{
  border:1px solid #eeeeee;
  background-color: #f5f5f5;
  padding:10px;
  border-radius: 3px;
}

.main{
  position: absolute;
}
.content{
    font-size: 12px;
  color: #999;
  line-height: 20px;
}
.titleMain{
    font-size: 14px;
    color: #191919;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.offline___NHq4e {
    position: absolute;
    top: -1px;
    right: -1px;
    padding: 0.5px 4px 0.5px 4px;
    /* width: 64px; */
    /* height: 22px; */
    background: rgba(255, 101, 247, 0.04);
    border-radius: 0 8px 0 8px;
    border: 1px solid rgba(187, 14, 255, 0.2);
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    color: #b336fc;
}
.box{
  position: relative;
    width: calc((100% - 80px)/4);
    padding: 20px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
    height: 130px;
}
@media screen and ( max-width: 1400px ) {
  .box{
    cursor: pointer;
    width: calc((100% - 60px)/3);
  }
}
.box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
}
.shadow:hover {
    border:1px solid #808080;border-radius:2px
}
.shadow {
    border:1px solid #ffffff;border-radius:2px
}

.xiang{
    padding: 1px 4px  1px 4px;
    background-color: #f7f7f7;
    border:1px solid #bbbbbb;
    border-radius: 3px;
    font-size: 10px;
    color:#bbbbbb;
}
  
/* .el-switch__core::after{
 height: 12px !important;
 width :12px !important;
} */
   
.title{
    margin-top: 10px;
    height: 30px;
    font-size: 13px;
    font-weight: bolder;
    border-radius: 3px;
    border-left: 5px solid #334157;

}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/shop/goods.vue